import type { Variant } from "./variant";

const DATA_TEST_IDS: Record<Variant, string> = {
  success: "toast.success",
  warning: "toast.warning",
  error: "toast.error",
  info: "toast.info",
  loading: "toast.loading",
  offline: "toast.offline",
};

export default DATA_TEST_IDS;
